import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {httpAccountAccesses, HttpAccountAccessesOptions} from '../http/accesses.http'
import {MUTATION_KEYS} from '@/queryClient'

export const useAccountAccesses = (
    options?: Omit<UseMutationOptions<unknown, AxiosError, HttpAccountAccessesOptions['payload']>, 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.ACCOUNT_ACCESS],
        mutationFn: payload => httpAccountAccesses({payload})
    })
}
